Ext.define('SA.VectorMapExportCropAspectRatioFieldSet', {
    alias: 'widget.vector-map-export-crop-aspect-ratio-fieldset',
    extend: 'Ext.form.FieldSet',

    checkboxToggle: true,
    cls: 'sa-map-export-crop-aspect-ratio-fieldset',

    layout: {
        align: 'stretch',
        type: 'vbox'
    },

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-map-export-field-row',
            margin: '0 0 20 0',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-map-export-standard-sizes-label',
                    html: 'Standard Sizes:'
                }, {
                    xtype: 'combo-button',
                    itemId: 'aspectRatio',
                    items: ['Letter', 'Legal', 'Tabloid'],
                    value: 'Letter',
                    width: 110
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-map-export-field-row',

            items: [
                {
                    xtype: 'component',
                    html: 'Orientation:'
                }, {
                    xtype: 'sa-radio-group',
                    itemId: 'orientation',
                    width: 110,

                    items: [
                        {value: 'landscape', boxLabel: 'Landscape', checked: true},
                        {value: 'portrait', boxLabel: 'Portrait'}
                    ]
                }
            ]
        }
    ],

    initComponent() {
        this.callParent();

        this.aspectRatio = this.down('#aspectRatio');
        this.orientation = this.down('#orientation');
    },

    createCheckboxCmp() {
        this.checkboxCmp = Ext.widget({
            xtype: 'sa-checkbox',
            boxLabel: 'Lock Aspect Ratio',
            checked: true,
            cls: 'sa-map-export-crop-aspect-ratio-fieldset-legend-checkbox',

            listeners: {
                change: this.onCheckChange,
                scope: this
            },

            setValue(value) {
                this.setChecked(value);
            }
        });

        return this.checkboxCmp;
    },

    initEvents() {
        this.callParent();

        this.aspectRatio.on('change', () => this.fireEvent('change', this));
        this.orientation.on('change', () => this.fireEvent('change', this));
    }
});